// extracted by mini-css-extract-plugin
export default {"host":"style_host__8PJkO","list":"style_list__XOl40","businessModel":"style_businessModel__mKgCR","industryTags":"style_industryTags__9oMxe","tagLink":"style_tagLink__1aU0T"};